// react
import { forwardRef } from 'react';

// material ui
import Button, { type ButtonProps } from '@mui/material/Button';

export type CancelButtonProps = Omit<ButtonProps, 'variant'>;

/**
 * Reusable "cancel" / dismiss action button.
 *
 * Thin wrapper around MUI `Button` that fixes `variant="text"` so cancel
 * actions are visually consistent and easy to spot in markup, without
 * imposing a custom color palette.
 */
export const CancelButton = forwardRef<HTMLButtonElement, CancelButtonProps>(
  (props, ref) => (
    <Button ref={ref} variant="text" data-testid="cancel-button" {...props} />
  ),
);

CancelButton.displayName = 'CancelButton';
